import _brilliantdirectories from './_brilliantdirectories'

export default function brilliantdirectories() {
    _brilliantdirectories.routeFn = true;
    return _brilliantdirectories;
}
